import {t} from '@lingui/core/macro';

import {isTranslate} from 'shared/lib/lang';

export const formatLimit = (value: number): string =>
    new Intl.NumberFormat(isTranslate() ? 'en-US' : 'ru-RU').format(value);

export const formatTariffLimit = (value: number): string =>
    value === 0 ? t`Нет` : formatLimit(value);
